import { useNavigate } from "react-router-dom";
import { MessageSquarePlus, Dumbbell, CalendarPlus, UsersRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const ACTIONS = [
  { id: "chat", icon: MessageSquarePlus, label: "New chat", desc: "Ask a question or upload homework", to: "/app/new" },
  { id: "practice", icon: Dumbbell, label: "Practice", desc: "Practice sets, mock exams and your exams in one place", to: "/app/practice" },
  { id: "add-exam", icon: CalendarPlus, label: "Add an exam", desc: "Count down to an exam and plan each day", to: "/app/exams?action=add" },
  { id: "groups", icon: UsersRound, label: "Study Groups", desc: "Join with a code, find a group or start your own", to: "/app/groups" },
];

export function QuickActions({ open, onOpenChange }) {
  const navigate = useNavigate();
  const pick = (a) => { onOpenChange(false); navigate(a.to); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121725] border-white/10 max-w-sm p-3 sm:rounded-2xl" data-testid="quick-actions">
        <DialogHeader className="px-2 pt-2">
          <DialogTitle className="font-display text-lg">Start something new</DialogTitle>
          <DialogDescription className="text-neutral-400 text-xs">Pick what you want to do.</DialogDescription>
        </DialogHeader>
        <div className="space-y-0.5">
          {ACTIONS.map((a) => (
            <button key={a.id} onClick={() => pick(a)} data-testid={`quick-${a.id}`}
              className="w-full flex items-center gap-3 px-2 py-2.5 rounded-xl text-left hover:bg-white/[0.06] outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 transition-colors">
              <span className="h-9 w-9 rounded-lg bg-sky-400/10 text-sky-300 flex items-center justify-center shrink-0"><a.icon className="h-[18px] w-[18px] stroke-[1.6]" /></span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm text-neutral-100">{a.label}</span>
                <span className="block text-xs text-neutral-500">{a.desc}</span>
              </span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
